<header class="wrapper">
  <a class="logo" [routerLink]="AppNavigation.Dashboard">
    <ng-container *pwLet="logo$ | async as logo">
      <img *ngIf="logo !== null" [src]="logo ? logo : 'content/browser/assets/logo.png'" alt="Logo" />
    </ng-container>
  </a>
  <h1 class="title">{{ title }}</h1>
  <div class="actions">
    <button mat-button (click)="signOut()">
      <i class="fa-regular fa-sign-out"></i>
      <span class="text">Log Out</span>
    </button>
  </div>
</header>
